var $c207a8811c9791e9$exports = {};
$c207a8811c9791e9$exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};


export {$c207a8811c9791e9$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
